import { AdmissionsCriteriaColor, AdmissionsCriterion, colorConfig } from 'components/shared/ai/AdmissionsCriteria';
import { AIJobCriterion } from 'models/AIJob';

export type CriteriaCategory = {
  label: string;
  color: AdmissionsCriteriaColor;
  criteria: AdmissionsCriterion[];
};

type SortableCriterion = AdmissionsCriterion & { order: number };
type SortableCategory = CriteriaCategory & { order: number; criteria: SortableCriterion[] };

export function groupCriteriaByCategory(criteria: AIJobCriterion[]): CriteriaCategory[] {
  const categoryMap = new Map<string, SortableCategory>();

  for (const criterion of criteria) {
    const { name: categoryName, color, order } = criterion.aiCriteriaSetCategory;

    if (!categoryMap.has(categoryName)) {
      categoryMap.set(categoryName, {
        label: categoryName,
        color: (color in colorConfig ? color : 'blue') as AdmissionsCriteriaColor,
        order,
        criteria: [],
      });
    }

    categoryMap.get(categoryName)!.criteria.push({
      title: criterion.aiCriteria.criterion,
      description: criterion.aiCriteria.description || undefined,
      sourceCount: criterion.sources.length,
      sources: criterion.sources.map((s) => ({
        attachmentId: s.attachmentId,
        displayId: s.displayId,
      })),
      order: criterion.aiCriteria.order,
    });
  }

  return Array.from(categoryMap.values())
    .sort((a, b) => a.order - b.order)
    .map((category) => ({
      label: category.label,
      color: category.color,
      criteria: (category.criteria as SortableCriterion[])
        .sort((a, b) => a.order - b.order)
        .map(({ order: _, ...c }) => c),
    }));
}
